// @ts-ignore
import { landinPageUrl } from '../../environment';
import React, { useState, useEffect } from 'react';
// import { userRegister } from '../../actions';
import { Button, Checkbox, Col, Form, Input, Row } from 'antd';
import { useDispatch } from 'react-redux';
import { userLogin } from '../../actions/user';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};

const LoginFrom = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
        const location = useLocation();
    const [integrationSessionId, setIntegrationSessionId] = useState<string | null>(null);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const sessionId = params.get('integration_session_id');
        if (sessionId) {
            setIntegrationSessionId(sessionId);
        }
    }, [location.search]);

    const [isRemember, setIsRemember] = useState<any>(true);

    const onFinish = (values: any) => {
        const payload = {
            email: values?.email,
            password: values?.password,
            // role: 'admin',
        };

        dispatch(
            userLogin(payload, (resp: any) => {
                if (resp?.success) {
                    if(isRemember) localStorage.setItem('token', resp?.token)
                    if (resp && resp?.data?.roleId === 2) {
                        if (integrationSessionId) {
                            return navigate(`/consent?integration_session_id=${integrationSessionId}`);
                        }
                        if (resp && !resp?.data?.isPasswordChanged) {
                            return navigate('/account', { state: { changePassword: true } });
                        }
                        if (resp && resp?.data?.isPasswordChanged && !resp?.data?.isSetupCompleted) {
                            return navigate('/setup', { state: '' });
                        }
                        if(resp && resp?.data?.isPasswordChanged && resp?.data?.isSetupCompleted) {
                            return navigate('/dashboard');
                        }
                    } else if (resp && resp?.data?.roleId === 3 && !resp?.data?.isPasswordChanged) {
                        return navigate('/account', { state: { changePassword: true } });
                    } else {
                        return navigate('/dashboard');
                    }

                }
            })
        );
    };

    return (
        <div className="authforms" style={{ padding: '152px 60px' }}>
            <div className="authHeadings">
                <button onClick={() => window.open(`${landinPageUrl}`, '_self') } className="btn textAuthHeading">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <rect
                            x="0.4"
                            y="0.4"
                            width="23.2"
                            height="23.2"
                            rx="11.6"
                            stroke="#F47523"
                            stroke-width="0.8"
                        />
                        <path
                            d="M14 8L10 12L14 16"
                            stroke="#F47523"
                            stroke-width="1.25"
                            stroke-linecap="round"
                        />
                    </svg>{' '}
                </button>

                <div className="textAuthHeading">
                    Log <span>In</span>
                </div>
            </div>
            <p>Enter your email and password for login. Thanks</p>

            <div className="row">
                <div className="col-12">
                    <Form
                        className="formControl"
                        {...layout}
                        form={form}
                        name="email_password_form"
                        onFinish={onFinish}
                        layout="vertical"
                        // onFinishFailed={onFinishFailed}
                        initialValues={{ remember: true }}
                    >
                        <Form.Item
                            className="formControlDesign"
                            label="Email"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your email!',
                                },
                                {
                                    type: 'email',
                                    message: 'The input is not valid E-mail!',
                                },
                            ]}
                        >
                            <Input autoComplete='new-email'/>
                        </Form.Item>

                        <Form.Item
                            className="formControlDesign passwordinputs"
                            label="Password"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your password!',
                                },
                                {
                                    min: 6,
                                    message:
                                        'Password must be at least 6 characters long!',
                                },
                            ]}
                        >
                            <Input.Password autoComplete="new-password" />
                        </Form.Item>
                        <Row>
                            <Col md={12}>
                                <Checkbox
                                    className="checkBoxdesign"
                                    defaultChecked={isRemember}
                                    // style={{ display: 'none'}}
                                    onChange={(evt: any) => {
                                        setIsRemember(evt.target.checked)
                                    }
                                 }
                                >
                                    Remember me{' '}
                                </Checkbox>
                            </Col>
                            <Col md={12}  style={{ textAlign: 'end'}}>
                            <Link to="/reset-password">
                            <Button style={{ backgroundColor: '#081525', color: '#f47523', border: 'none', fontWeight: "bold" }}>
                                <u><i>Forgot Password</i></u>
                            </Button>
                            </Link>
                            </Col>

                            <Col lg={24} style={{ marginBottom: '8px', textAlign: 'center' }}>
                                <span
                                    style={{ cursor: 'pointer', color: '#F47523', fontSize: '16px' }}
                                    onClick={() => {
                                        const registerUrl = integrationSessionId ? `${landinPageUrl}/register?integration_session_id=${integrationSessionId}` : `${landinPageUrl}/register`;
                                        window.open(registerUrl, '_self');
                                    }}>
                                    Don't have an account? Register
                                </span>
                            </Col>
                        </Row>
                        <Form.Item>
                            <Button
                                className="btn btn-primary text-right w-100 mt-15"
                                type="primary"
                                htmlType="submit"
                            >
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                        <div style={{textAlign: 'center'}}><a href="mailto:info@referusnetwork.com" style={{ textDecoration: 'none', color: '#F47523', fontSize: '16px', textAlign: 'center' }}>
                                Need Help! Contact Support
                            </a>
                            </div>
                </div>
            </div>
        </div>
    );
};

export default LoginFrom;
